import { render, staticRenderFns } from "./DeterminacionesTipoTumoral.vue?vue&type=template&id=588b9a8f&scoped=true&"
import script from "./DeterminacionesTipoTumoral.vue?vue&type=script&lang=js&"
export * from "./DeterminacionesTipoTumoral.vue?vue&type=script&lang=js&"
import style0 from "./DeterminacionesTipoTumoral.vue?vue&type=style&index=0&id=588b9a8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b9a8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSkeletonLoader})
